export abstract class BaseModel {
  public _id?: string;
  public createdAt?: Date;
  public updatedAt?: Date;
}
